import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, CircularProgress} from 'views/components';

import HourlyRateContent from './payment_plan/hourly_rate/Content';

const PaymentPlan = (props) => {
  const caregiverRn = props.caregiverRn;
  const refresh = props.refresh;
  const caregiverBackend = props.caregiverBackend;
  const caregiverPaymentPlan = props.caregiverPaymentPlan;
  const caregiverPaymentPlanLoading = props.caregiverPaymentPlanLoading;

  React.useEffect(() => {
    caregiverBackend.payment.loadCaregiverPaymentPlan();
  }, [caregiverRn, refresh]);

  const updateCaregiverHourlyRate = (newValue, onSuccess) => {
    caregiverBackend.payment.updateCaregiverHourlyRate(newValue, onSuccess);
  };

  if (caregiverPaymentPlanLoading) {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Stack
      spacing={2}
      direction={'row'}
      justifyContent="space-between"
      sx={{
        width: '100%',
      }}
    >
      <Box
        sx={{
          width: '50%',
        }}
      >
        <HourlyRateContent
          caregiverPaymentPlan={caregiverPaymentPlan || {}}
          updateCaregiverHourlyRate={updateCaregiverHourlyRate}
        />
      </Box>
    </Stack>
  );
};

PaymentPlan.propTypes = {
  refresh: PropTypes.number.isRequired,
  caregiverRn: PropTypes.string.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  caregiverPaymentPlan: PropTypes.object.isRequired,
  caregiverPaymentPlanLoading: PropTypes.bool.isRequired,
};

export default React.memo(PaymentPlan);
